// 共通ヒートマップ色ユーティリティ（Step3/Analysisで共通使用）

// 右側（AVGなど）の黄色系スケール（Step3準拠）
export const getYellowShade = value => {
  if (value <= 0 || value < 1) return '#fffef7';
  const normalizedValue = Math.min(Math.max(value, 1), 10.0);
  const ratio = (normalizedValue - 1) / (10.0 - 1);
  if (ratio <= 0.1) return '#fffef9';
  if (ratio <= 0.2) return '#fffdf2';
  if (ratio <= 0.3) return '#fffbeb';
  if (ratio <= 0.4) return '#fff8e1';
  if (ratio <= 0.5) return '#fff5d6';
  if (ratio <= 0.6) return '#fff2cc';
  if (ratio <= 0.7) return '#ffefbf';
  if (ratio <= 0.8) return '#ffecb3';
  if (ratio <= 0.9) return '#ffe9a6';
  return '#ffec99';
};

// 高域色（Step3準拠の補助）
export const getHighColor = v => {
  if (v >= 8) return '#52c41a';
  if (v >= 6) return '#a0d911';
  return '#fadb14';
};

// トピック用（黄色系）: Step3の黄色スケールと整合するよう getYellowShade を使用
export const getHeatmapColor = (value, max = 10.0) => {
  if (!value || value <= 0) return '#fffef7';
  return getYellowShade(value);
};

// 重要語句用（水色系）
export const getTermsHeatmapColor = (value, max = 10.0) => {
  if (value === 0 || value < 0.1) return '#f0fdff';
  const ratio = Math.min(Math.max(value / max, 0.1), 1);
  if (ratio <= 0.2) return '#e6faff';
  if (ratio <= 0.35) return '#d6f5ff';
  if (ratio <= 0.5) return '#c6f0ff';
  if (ratio <= 0.7) return '#b3ebff';
  if (ratio <= 0.85) return '#9fe6ff';
  return '#8fe2ff';
};

// 関連キーワード用（緑系）
export const getRelatedHeatmapColor = (value, max = 10.0) => {
  if (value === 0 || value < 0.1) return '#f6ffed';
  const ratio = Math.min(Math.max(value / max, 0.1), 1);
  if (ratio <= 0.2) return '#eaffea';
  if (ratio <= 0.35) return '#d9f7be';
  if (ratio <= 0.5) return '#c8f5a9';
  if (ratio <= 0.7) return '#b7eb8f';
  if (ratio <= 0.85) return '#95de64';
  return '#73d13d';
};

// LSI用（紫系）
export const getLSIHeatmapColor = (value, max = 10.0) => {
  if (value === 0 || value < 0.1) return '#f9f0ff';
  const ratio = Math.min(Math.max(value / max, 0.1), 1);
  if (ratio <= 0.2) return '#f4e6ff';
  if (ratio <= 0.35) return '#f0d5ff';
  if (ratio <= 0.5) return '#eabfff';
  if (ratio <= 0.7) return '#d3adf7';
  if (ratio <= 0.85) return '#b37feb';
  return '#9254de';
};

export default {
  getYellowShade,
  getHighColor,
  getHeatmapColor,
  getTermsHeatmapColor,
  getRelatedHeatmapColor,
  getLSIHeatmapColor,
};
